// The last thing the user did (click, key, wheel, touch), shared by the tabs of the
// site through localStorage: working in one tab keeps the others alive. After session_idle_minutes
// (core, /check) without an action the page logs out; core refuses the refresh of a session left
// alone as well. Requests the page makes by itself (polling, auto-refresh) are not actions.
const KEY = 'sledograf:last_activity';
const WRITE_EVERY_MS = 5000;
// only what a person does: «scroll» also fires when the page scrolls an element itself and
// «mousemove» when an animation moves under a resting cursor - a statistics page left open kept
// the session alive for hours (27.10.2026). Scrolling by the user comes as wheel, keys or touch.
const EVENTS = ['mousedown', 'pointerdown', 'keydown', 'wheel', 'touchstart'];

let memory = 0;
let idleMinutes = 60;

export function setIdleMinutes(minutes) {
  if (Number(minutes) > 0) idleMinutes = Number(minutes);
}

export function idleLimitMinutes() {
  return idleMinutes;
}

export function lastActivity() {
  let stored = 0;
  try {
    stored = Number(window.localStorage.getItem(KEY)) || 0;
  } catch (e) {
    stored = 0;
  }
  return Math.max(memory, stored);
}

export function markActivity(now = Date.now(), force = false) {
  if (!force && now - memory < WRITE_EVERY_MS) return;
  memory = now;
  try {
    window.localStorage.setItem(KEY, String(now));
  } catch (e) {
    // storage blocked: this tab still counts its own actions
  }
}

// No action known (first visit) is not idle: the page marks the visit itself
export function isIdle(last, now, minutes) {
  return last > 0 && now - last >= minutes * 60000;
}

export function sessionIdle(now = Date.now()) {
  return isIdle(lastActivity(), now, idleMinutes);
}

// a lone modifier is not an action: Cmd of Cmd+Tab reaches the page that had the focus, and
// switching windows kept an untouched session alive (27.10.2026)
const MODIFIERS = new Set(['Meta', 'Control', 'Alt', 'Shift', 'CapsLock', 'OS', 'AltGraph', 'Fn']);

export function isAction(event) {
  return !(event && event.type === 'keydown' && MODIFIERS.has(event.key));
}

let started = false;
const onAction = (event) => { if (isAction(event)) markActivity(); };

export function startActivityTracking() {
  if (started) return;
  started = true;
  EVENTS.forEach(name => window.addEventListener(name, onAction, { passive: true, capture: true }));
}
